import { render, staticRenderFns } from "./408.vue?vue&type=template&id=0acb0c56&scoped=true&"
import script from "./408.vue?vue&type=script&lang=js&"
export * from "./408.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0acb0c56",
  null
  
)

export default component.exports